document.addEventListener("DOMContentLoaded", function () {
  const slider = document.querySelector(".Banner_Slider");
  const prevArrow = slider.parentElement.querySelector(".prev");
  const nextArrow = slider.parentElement.querySelector(".next");
  const swiper = new Swiper(".Banner_Slider", {
    loop: true,
    slidesPerView: 1,
    spaceBetween: 0,
    direction: "horizontal",

    speed: 1000,
    parallax: true,
    navigation: {
      nextEl: nextArrow,
      prevEl: prevArrow,
    },
    // autoplay: {
    //   delay: 4000,
    //   disableOnInteraction: false,
    // },
  });
});
document.addEventListener("DOMContentLoaded", function () {
  const sections = document.querySelectorAll(".products__section");

  sections.forEach((section) => {
    const slider = section.querySelector(".Products__lists");

    if (!slider) return;

    const prevArrow = section.querySelector(".prev");
    const nextArrow = section.querySelector(".next");

    new Swiper(slider, {
      direction: "horizontal",
      speed: 1000,

      navigation: {
        nextEl: nextArrow,
        prevEl: prevArrow,
      },

      breakpoints: {
        150: {
          slidesPerView: 1.5,
          spaceBetween: 10,
        },

        576: {
          slidesPerView: 2.5,
          spaceBetween: 10,
        },

        769: {
          slidesPerView: 2.6,
          spaceBetween: 10,
        },

        1025: {
          slidesPerView: 3.3,
          spaceBetween: 20,
        },

        1200: {
          slidesPerView: 4,
          spaceBetween: 20,
        },
      },
    });
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const sections = document.querySelectorAll(".products__section");

  sections.forEach((section) => {
    const slider = section.querySelector(".blogs__lists");

    if (!slider) return;

    const prevArrow = section.querySelector(".prev");
    const nextArrow = section.querySelector(".next");

    new Swiper(slider, {
      direction: "horizontal",
      speed: 1000,

      navigation: {
        nextEl: nextArrow,
        prevEl: prevArrow,
      },

      breakpoints: {
        150: {
          slidesPerView: 1,
          spaceBetween: 10,
        },

        576: {
          slidesPerView: 2.1,
          spaceBetween: 10,
        },

        769: {
          slidesPerView: 2.4,
          spaceBetween: 10,
        },

        1025: {
          slidesPerView:2.7,
          spaceBetween: 20,
        },

        1200: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
      },
    });
  });
});
